export default "__VITE_ASSET__CTwKYqMo__"